import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ExpIngredientsComponent from '@app/components/apps/FeedExpectedIngredients/FeedExpIngredient';

const AddExpIngredient = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Feed Expected Ingredient');

  const routes = [
    { path: '/feed-exp-ingredients', breadcrumbName: 'Feed Expected Ingredients' },
    { path: '/add-exp-ingredient', breadcrumbName: 'Add Feed Expected Ingredient' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ExpIngredientsComponent
          editable={true}
          pageTitle={'Add Feed Expected Ingredient'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default AddExpIngredient;
